import React from 'react'
import TextField from '@material-ui/core/TextField'
import { CreateContactInput } from 'src/graphql'

import { CompanyShenanigans } from '../../types'

const style: React.CSSProperties = { width: '32%', minWidth: 250 }

type Props<T extends CreateContactInput> = {
  contact: T
  onChange: (update: Partial<T>) => void
  fields: object
  isCompanyVisible?: boolean
}

const NameForm = <T extends CreateContactInput & CompanyShenanigans>(
  props: Props<T>,
) => {
  const {
    contact: { firstName, lastName, companyName, company },
    fields,
    onChange,
    isCompanyVisible = true,
  } = props

  const handleChange = <K extends keyof T>(key: K, value: T[K]) => {
    onChange(({ [key]: value } as unknown) as Partial<T>)
  }

  return (
    <>
      <TextField
        id={'first_name_field'}
        value={firstName}
        label={'First Name'}
        onChange={e => handleChange('firstName', e.target.value)}
        {...fields}
        style={{ ...style, marginRight: 15 }}
      />
      <TextField
        value={lastName}
        label={'Last Name'}
        onChange={e => handleChange('lastName', e.target.value)}
        {...fields}
        style={{ ...style, marginRight: 15 }}
      />
      {isCompanyVisible && (
        <TextField
          value={companyName ?? company}
          label={'Company Name'}
          onChange={e => {
            handleChange('companyName', e.target.value)
            handleChange('company', e.target.value)
          }}
          {...fields}
          style={style}
        />
      )}
    </>
  )
}

export default NameForm
